var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxBoldAirplaneSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zm9.69 11.85-3.35-1.44c-.39-.16-.7.04-.7.46v1.85c0 .16.09.39.21.51l1.64 1.65c.17.17.25.51.17.74l-.32.96c-.14.42-.62.62-1.01.42l-1.67-1.42c-.26-.21-.68-.21-.93 0L9.86 19c-.4.2-.87 0-1.01-.43l-.32-.96c-.08-.23 0-.57.17-.74l1.67-1.64c.11-.11.21-.34.21-.51v-1.85c0-.42-.32-.63-.7-.46l-3.35 1.44c-.56.24-1.01-.06-1.01-.66v-.93c0-.48.37-1.04.81-1.23l3.94-1.7c.16-.07.3-.28.3-.46V6.8c0-.68.49-1.49 1.1-1.79.22-.11.47-.11.69 0 .6.31 1.1 1.11 1.1 1.79v2.07c0 .18.13.39.3.46l3.94 1.7c.45.19.81.75.81 1.23v.93c0 .6-.46.9-1.01.66z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldAirplaneSquare);
export default __webpack_public_path__ + "static/media/vuesax-bold-airplane-square.e3e467a5f135aa9b76a3dd0bca8cc8be.svg";
export { ForwardRef as ReactComponent };